import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocalizedProperty } from "../../../../utils";

export function AgreementHistoryTable({ history }) {
    const { t } = useTranslation();
    const getLocalized = useLocalizedProperty();

    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                {t("agreements.historyOfChanges.title")}
            </Typography>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: "primary.main" }}>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.childKind")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.childType")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.childNumber")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.parentKind")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.parentNumber")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.note")}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                                {t("agreements.historyOfChanges.dateChange")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {history.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    {t("common.noData")}
                                </TableCell>
                            </TableRow>
                        ) : (
                            history.map((h) => (
                                <TableRow
                                    key={h.agrelog_child}
                                    sx={{ "&:last-child td": { border: 0 } }}
                                >
                                    <TableCell>
                                        {getLocalized(h.agrelog_child_kind, "agrekind_name") || "—"}
                                    </TableCell>
                                    <TableCell>
                                        {getLocalized(h.agrelog_child_type, "agretype_name") || "—"}
                                    </TableCell>
                                    <TableCell>{h.agrelog_child_number || "—"}</TableCell>
                                    <TableCell>
                                        {getLocalized(h.agrelog_parent_kind, "agrekind_name") ||
                                            "—"}
                                    </TableCell>
                                    <TableCell>{h.agrelog_parent_number || "—"}</TableCell>
                                    <TableCell>{h.agrelog_note || "—"}</TableCell>
                                    <TableCell>
                                        {dayjs(h.date_updated).format("YYYY-MM-DD")}
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
